"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Veertualtech = void 0;
const helper_1 = require("../../helper");
const EmrConstants_1 = require("../../EmrConstants");
class Veertualtech {
    constructor() { }
    parse(pastedData, event, callbackEmit) {
        pastedData = pastedData.replace(/\r\n/g, "\n");
        try {
            const patientInfo = this.gettingPatientDetails(pastedData);
            const insurance = this.getInsurance(pastedData);
            const contactDetails = this.getContactDetails(pastedData);
            const sendCallBackData = Object.assign(Object.assign(Object.assign({}, patientInfo), insurance), contactDetails);
            //@callback
            callbackEmit({ parseData: sendCallBackData });
        }
        catch (error) {
            //For Error logs
            callbackEmit({
                parseData: {},
                isDataParsed: 0,
                errorMessage: error ? error === null || error === void 0 ? void 0 : error.message : error,
                errorStack: error === null || error === void 0 ? void 0 : error.stack,
            });
        }
    }
    /**
     * @function gettingPatientDetails
     * @param sessionFirst {String}
     * @param sessionSecond {String}
     * @summary Getting Patient name, number, email, dob, address from Synergy
     */
    gettingPatientDetails(sessionFirst) {
        const Dob = (0, helper_1.substrInBetweenNew)(sessionFirst, "DOB", "\n");
        return {
            patientInfo: Object.assign(Object.assign(Object.assign({}, this.patientName(sessionFirst)), this.patientPhoneNumberWithAddress(sessionFirst)), { dob: (0, helper_1.getDOB)(Dob, true) }),
        };
    }
    /**
     * @function getInsurance
     * @param sessionThird
     * @summary Getting Insurance from Synergy
     */
    getInsurance(sessionThird) {
        let insurance = (0, helper_1.substrInBetweenNew)(sessionThird, "Primary Insurance:", "Secondary Insurance:");
        insurance = (0, helper_1.trim)(insurance).replace("\n", " ");
        return {
            insurance,
        };
    }
    /**
     * @function getPrimaryPhysician
     * @param data
     * @param sessionEight
     * @summary Getting Physician and Pharmacy from Synergy
     */
    getContactDetails(contactDetails) {
        const physiciansRaw = (0, helper_1.substrInBetweenInclusive)(contactDetails, "Primary Physician:", "Referred by:");
        const primaryPhy = {
            info: {
                physician: this.getPhysician(physiciansRaw),
                pharmacy: this.getPharmacy(contactDetails),
                careGiver: this.getCaregiver(contactDetails),
            },
        };
        //@Return
        return primaryPhy;
    }
    getPhysician(data) {
        const physicians = [];
        const physicianNameRaw = (0, helper_1.trim)((0, helper_1.substrInBetweenNew)(data, "Primary Physician:", "NPI:"));
        const physicianNameParts = physicianNameRaw.split(",");
        const name = (0, helper_1.trim)(`${physicianNameParts[1]} ${physicianNameParts[0]}`);
        const numbersRaw = (0, helper_1.substrInBetweenNew)(data, "Phone:", "Fax:");
        const phoneNo = (0, helper_1.changeNumberUSFormat)((0, helper_1.trim)(numbersRaw.replace(/[\s-()]/g, "")));
        if (name && phoneNo) {
            physicians.push({
                name,
                phoneNo,
                countryCode: EmrConstants_1.DEFAULT_COUNTRY_CODE,
                sortOrder: 1,
            });
        }
        return physicians;
    }
    /**
     * @function getPharmacy
     * @param data
     */
    getPharmacy(data) {
        const pharmacies = [];
        const pharmacyRaw = (0, helper_1.substrInBetweenInclusive)(data, "Pharmacy:", "Clinicians:");
        const name = (0, helper_1.trim)((0, helper_1.substrInBetweenNew)(pharmacyRaw, "Pharmacy:", "Phone"));
        const phoneNoRaw = (0, helper_1.substrInBetweenNew)(pharmacyRaw, "Phone:", "Fax:");
        const phoneNo = (0, helper_1.changeNumberUSFormat)((0, helper_1.trim)(phoneNoRaw.replace(/[\s-()]/g, "")));
        if (name && phoneNo) {
            pharmacies.push({
                name,
                phoneNo,
                countryCode: EmrConstants_1.DEFAULT_COUNTRY_CODE,
                sortOrder: 1,
            });
        }
        return pharmacies;
    }
    getCaregiver(data) {
        const caregivers = [];
        const contactPersonText = (0, helper_1.substrInBetweenInclusive)(data, "Contact Person:", "Marital Status:");
        const nameRaw = (0, helper_1.trim)((0, helper_1.substrInBetweenNew)(contactPersonText, "Contact Person:", "Secondary Language:"));
        const cellPhoneRaw = (0, helper_1.substrInBetweenNew)(contactPersonText, "(Home)", "(Mobile)");
        const homePhoneRaw = (0, helper_1.substrInBetweenNew)(contactPersonText, "Contact Phone:", "(Home)");
        const number = (0, helper_1.changeNumberUSFormat)((0, helper_1.trim)(cellPhoneRaw || homePhoneRaw)
            .replace(/\s/, "")
            .replace(/[\s-()]/g, ""));
        caregivers.push({
            name: nameRaw,
            phoneNo: number,
            countryCode: EmrConstants_1.DEFAULT_COUNTRY_CODE,
            sortOrder: 1,
        });
        return caregivers;
    }
    /**
     * @function patientPhoneNumberWithAddress
     * @param firstSession
     * @summary Patient number or Address both are same session
     */
    patientPhoneNumberWithAddress(firstSession) {
        const info = {
            phoneNo: "",
            address: {
                placeName: "",
                apartmentNo: "",
            },
        };
        const cellPhoneRaw = (0, helper_1.substrInBetweenNew)(firstSession, "Cell Phone:", "Primary Language:");
        const cellPhoneNumber = (0, helper_1.trim)(cellPhoneRaw.replace(/[\s-()]/g, ""));
        const homePhoneRaw = (0, helper_1.substrInBetweenNew)(firstSession, "Home Phone:", "Acuity:");
        const homePhoneNumber = (0, helper_1.trim)(homePhoneRaw.replace(/[\s-()]/g, ""));
        info.phoneNo = (0, helper_1.changeNumberUSFormat)(cellPhoneNumber || homePhoneNumber);
        const addressString = (0, helper_1.substrInBetweenNew)(firstSession, "Address:", "Ethnicity:");
        info.address.placeName = (0, helper_1.trim)(addressString).replace(/\n/g, ", ");
        return info;
    }
    /**
     * @function patientName
     * @param sessionFirst {String}
     * @summary Getting Patient First name, Last name from string
     * @returns {name} FullName
     */
    patientName(sessionFirst) {
        const name = {
            firstName: "",
            lastName: "",
        };
        const nameText = (0, helper_1.substrInBetweenNew)(sessionFirst, "Patient Name:", "MR No.");
        name.firstName = (0, helper_1.trim)(nameText.split(",")[1]);
        name.lastName = (0, helper_1.trim)(nameText.split(",")[0]);
        return name;
    }
}
exports.Veertualtech = Veertualtech;
